module.exports = __webpack_public_path__ + "static/product-3-3a3dbde59abf1f4639d227f4415c3292.png";